import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticStyle:{"border":"2px solid #e2e2e5","background-color":"white"},attrs:{"small":"","icon":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v("edit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }